import React from 'react'

function DocViewer({ url, setDocViewer }) {
  return (
    <>
      <div
        dir="rtl"
        className="fixed  inset-0 z-50 w-screen h-screen flex flex-col  items-center justify-center overflow-x-hidden overflow-y-auto outline-none focus:outline-none"
      >
        <div
          onClick={(e) => setDocViewer(false)}
          className=" text-red-500 border w-fit px-3 rounded-lg my-1 hover:cursor-pointer text-left bg-white "
        >
          Close
        </div>
        <iframe
          src={url}
          className="w-[70%]  h-[80%]  p-4 border border-gray-500 rounded-lg text-bl bg-black flex flex-col overflow-y-scroll gap-3"
        />
      </div>
      <div className="fixed inset-0 z-40 bg-black opacity-25"></div>
    </>
  );
}

export default DocViewer